<template>
    <div class="content_container">
        <div class="blog_title font-active">
            <h1>{{ data.title }}</h1>
            <p class="mb-0"><i>Written by {{ data.author }}</i></p>
        </div>
        <div class="black_friday_blog mt-5" v-if="data.blog_offer">
            <div class="img_friday">
                <img  :src="data.blog_offer.image" width="150" height="150" alt="blog offer" />
            </div>
            <div class="text_friday">
                <h3 class="font-active">{{data.blog_offer.title}}</h3>
                <p class="mb-3">{{data.blog_offer.description}}</p>
                <router-link :to="getCta(data.blog_offer.link)">{{data.blog_offer.cta}}</router-link>
            </div>
        </div>
        <div class="blog_banner mt-5">
            <img class="radious_eight" height="827" width="576" :alt="data.title" :src="data.bnr_image" />
        </div>
       
        <div class="blog_content" v-html="data.description"></div>
    </div>
</template>

<script setup>
    const {data} = defineProps(['data'])

    //Define the method
    const getCta = (link) => {
        return link.replace("https://friendlydiamonds.com", "")
    }

    // Lifecycle hook
    onMounted(() => {
        const a_values = ['#one_anker', '#two_anker', '#three_anker', '#four_anker', '#five_anker', '#six_anker', '#seven_anker', '#eight_anker', '#nine_anker', '#ten_anker']
        const h2_values = ['one_anker', 'two_anker', 'three_anker', 'four_anker', 'five_anker', 'six_anker', 'seven_anker', 'eight_anker', 'nine_anker', 'ten_anker']

        const a_elem = document.querySelectorAll('.blog_content > ul > li > a')
        const h2_elem = document.querySelectorAll('.blog_content h2')

        for (let i = 0; i < a_elem.length; i++) {
            a_elem[i].setAttribute("href", a_values[i])
        }

        for (let i = 0; i < h2_elem.length; i++) {
            h2_elem[i].setAttribute("id", h2_values[i])
        }
    })
</script>

<style>

a{
    color: var(--green);
}
.black_friday_blog {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    border-radius: 6px;
    padding: 10px 10px 15px 10px;
}

.img_friday {
    width: 30%;
    padding-right: 15px;
    
}

.text_friday {
    width: 70%;
}

.text_friday h3 {
    font-size: 22px;
    color: #212529;
}

.text_friday a {
    text-transform: uppercase;
    font-size: 14px;
    color: #fff;
    background: var(--green);
    padding: 5px 10px;
    display: inline-block;
}
.text_friday a:hover{
    color: #fff;
}
.content_container {
    border-bottom: 1px solid #e2e2e2;
    padding-bottom: 15%;
}
.blog_title h1{
    font-size: 48px;
    line-height: 56px;
}
.blog_title p{
    font-size: 16px;
}
.blog_content p{
    font-family: 'NewYork';
    color: #606060;
    line-height: 24px;
    margin-bottom: 32px;
}
.blog_content p a{
    text-decoration: underline;
    font-weight: 500 !important;
    border-radius: 8px;
 }
.blog_content h2{
    font-family: 'NewYork';
    font-size: 40px;
    margin-bottom: 24px !important;
    line-height: 48px;
}
/* .blog_content h2 strong, .blog_content h2 b {
    font-weight: inherit;
} */
.blog_content h3{
    font-family: 'NewYork';
    font-size: 32px;
    margin-bottom: 24px !important;
    line-height: 40px;
}
.blog_content h4{
    font-family: 'NewYork';
    font-size: 24px;
    margin-bottom: 24px !important;
    line-height: 32px;
}
.blog_content h6 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 24px;
}
.blog_content img {
    border-radius: 8px;
}
.blog_banner{
    margin-bottom: 40px;
}
.blog_content ul {
    padding-left: 20px;
    font-family: 'NewYork';
    margin-bottom: 32px;
}
.blog_content ul li a {
    font-size: 16px;
    text-align: left;
    color: #606060;

}
.blog_content ul li {
    line-height: 24px;
    color: #606060;
    margin-bottom: 8px;
}
.blog_content ul li a:hover {
    color: #606060;
}

@media(max-width: 1150px){
    .blog_title h1 {
        font-size: 38px;
        line-height: 46px;
    }
    .blog_content h2 {
        font-size: 32px;
    }
    .blog_content h3 {
        font-size: 28px;
        line-height: 36px;
    }
    .blog_content h4 {
        font-size: 22px;
        line-height: 32px;
    }
    .articles_box span.art_title{
        font-size: 18px;
    }
}
@media(max-width: 992px){
    .content_container {
       
        padding-bottom: 20px;
    }
}
@media(max-width: 767px){
    .black_friday_blog{
        padding: 15px 10px;
    }
    .text_friday h3 {
        font-size: 18px;
    }
    .text_friday p {
        font-size: 14px;
    }
    .content_container {
        border-bottom: 0;
        padding-bottom: 0;
    }
    .blog_title h1 {
        font-size: 32px;
        line-height: 46px;
        margin-bottom: 30px;
    }
    .blog_content h2 {
        font-size: 26px;
        line-height: 34px;
    }
    .blog_content h6 {
        font-size: 14px;
    }
    .blog_content h3 {
        font-size: 26px;
        line-height: 34px;
    }
    .blog_content h4 {
        font-size: 20px;
        line-height: 28px;
    }
}
</style>
